import React, { useState } from "react";
import TabContainer from "../../components/SupplierInventoryManagement/TabContainer";
import ProductBasedInventory from "../../components/SupplierInventoryManagement/ProductBasedInventory";
import SupplierInventoryPage from "../../components/SupplierInventoryManagement/WarehouseBasedInventory/SupplierInventoryPage";

const InventoryManagement = () => {
  const [activeTab, setActiveTab] = useState("warehouse-based");

  const tabs = [
    { id: "warehouse-based", label: "مدیریت موجودی بر اساس انبار" },
    { id: "product-based", label: "مدیریت موجودی بر اساس کالا" }
  ];

  return (
    <div className="p-2" dir="rtl">
      <TabContainer
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      >
        {activeTab === "warehouse-based" ? (
          <SupplierInventoryPage />
        ) : (
          <ProductBasedInventory />
        )}
      </TabContainer>
    </div>
  );
};

export default InventoryManagement;